import { Permissions, usePermissions } from "contexts/permissionCtx";

export const useHasPermission = (key: keyof Permissions) => {
  const { permissions } = usePermissions();
  return Boolean(permissions?.[key]);
};
